(function($) {
  $('[data-svg]').each(function(i, el) {
    var
    DATA = $(this).data(),
    s = DATA.svg,
    w = DATA.svgWidth,
    h = DATA.svgHeight,
    c = DATA.svgClass,
    f = DATA.svgFill || 'currentColor',
    sty = DATA.svgStyle,
    id = DATA.svgId;

    $.get(s, function(res) {
      var $svg = $(res).find('svg');
      (id) ? $svg.attr('id', id) : null;
      (c) ? $svg.addClass(c) : null;
      (w) ? $svg.attr('width', w) : null;
      (h) ? $svg.attr('height', h) : null;
      (f) ? $svg.attr('fill', f) : null;
      (sty) ? $svg.attr('style', sty) : null;
      $(el).after($svg);
      $(el).remove();
    });
  });
})(jQuery);